/**
 * Off-site http(s) links in RTE / blog HTML open in a new tab so a BuyFineDiamonds
 * or WhatsApp URL authored in Shopify Admin does not dump the shopper out of the store.
 *
 * Same hostname stays in this tab. tel: / mailto: / relative paths are skipped.
 * Links that already have target=_blank are left alone.
 */
(function markExternalLinks() {
  const host = (window.location.hostname || '').replace(/^www\./, '');

  document.querySelectorAll('a[href]').forEach((anchor) => {
    if (anchor.target === '_blank') return;

    const raw = (anchor.getAttribute('href') || '').trim();
    if (!/^https?:\/\//i.test(raw)) return;

    let linkHost = '';
    try {
      linkHost = new URL(raw, window.location.origin).hostname.replace(/^www\./, '');
    } catch (error) {
      return;
    }
    if (!linkHost || linkHost === host) return;

    anchor.target = '_blank';
    const rel = (anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (!rel.includes('noopener')) rel.push('noopener');
    anchor.setAttribute('rel', rel.join(' '));
  });
})();
